import { DateCellType, registerCellType } from 'handsontable/cellTypes';
import { DateEditor } from 'handsontable/editors';

/**
 * Handsontable's date editor (a native date input) that saves a date picked from the browser's date
 * picker straight into the cell, as the Pikaday calendar did before Handsontable 18. The native input
 * otherwise keeps the picked date until the editor closes, so the cell looked as if nothing was picked.
 * A typed date still saves on Enter or when the editor closes: typing fires `change` as soon as the
 * date is complete, which would otherwise close the editor mid-edit.
 */
export class NativeDateEditor extends DateEditor {
  private typedSinceChange = false;

  /**
   * Registers the editor for the `date` cell type, keeping Handsontable's date renderer and validator.
   */
  static register(): void {
    registerCellType({ ...DateCellType, editor: NativeDateEditor });
  }

  createElements(type?: string): void {
    super.createElements(type);

    // The browser's date picker does not send key events to the page, so a keydown means the date is
    // being typed rather than picked.
    this.TEXTAREA.addEventListener('keydown', () => {
      this.typedSinceChange = true;
    });
    this.TEXTAREA.addEventListener('change', () => {
      const pickedFromDatePicker = !this.typedSinceChange;
      this.typedSinceChange = false;
      if (pickedFromDatePicker && this.isOpened()) {
        this.finishEditing();
      }
    });
  }

  beginEditing(newInitialValue?: unknown, event?: Event): void {
    this.typedSinceChange = false;
    super.beginEditing(newInitialValue, event);
  }
}
